import React, {forwardRef, useCallback, useEffect, useRef, useState } from "react";
import {
  Dialog,
  Slide,
  Box,
  Typography,
//   IconButton,
//   TextField,
//   InputAdornment,
} from "@mui/material";

// import CloseIcon from "@mui/icons-material/Close";
// import SendIcon from "@mui/icons-material/Send";
import { FaUserAlt } from "react-icons/fa";
import { FaRobot } from "react-icons/fa";
import { useSearchParams } from "react-router-dom";
import axiosInstance from "./axiosInstance";
import { fetchHistoryByMobileNo } from "../Components/shared/ApiEndpoint";
// import { Button } from "react-bootstrap";
// import { MdOutlineRestartAlt } from "react-icons/md";
// import axiosInstance from "./axiosInstance";
// import { answerApi, fetchHistoryByMobileNo } from "../Components/shared/ApiEndpoint";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CrmChatbox =() => { 
const [open, setOpen] = useState(true);
  const [searchParam, setSearchParam] = useSearchParams();
  const initialValue = searchParam.get("phone_number");
  const token = searchParam.get("token");
  const email = searchParam.get("email");
  const messagesEndRef = useRef(null);
  // eslint-disable-next-line no-unused-vars
  const [userName, setUserName] = useState(null);
  const [messages, setMessages] = useState([
    {
      direction: "",
      text: "",
    },
  ]);

useEffect(() => {
  let phone = initialValue;
  let defToken = token;
  let defemail = email;
  // If URL has no phone number → set it
if (!phone) {
  phone = "6381654628";
  searchParam.set("phone_number", phone);
  setSearchParam(searchParam);
}

// Add token if missing
if (!defToken) {
  // defToken = "IlblTrNOVZctlURtMysuApvIEnFgGx_MgWXtLHuzU80="; // put your token
  defToken = "ndCFt0fWtblo9O03M-WV0uP_dxPC1ouPLvf3EguUZ5w="
  searchParam.set("token", defToken);
  setSearchParam(searchParam);
}

if (!email){
  defemail="hellopradeep04@gmail.com";
   searchParam.set("email", defemail);
  setSearchParam(searchParam);
}

  // Now fetch using the final phone number
  fetchNumberHist(phone);

}, []);

  useEffect(() => {
  if (messagesEndRef.current) {
    messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
  }
}, [messages]);

  const handleToggle = () => setOpen((prev) => !prev);

 
const fetchNumberHist = useCallback(async (phone) => {
  try {
    const res = await axiosInstance.post(fetchHistoryByMobileNo,
       {
         mobile_number: `91${phone}`,
         client_signature:token,
         email:email
      }, 
       { withCredentials: true });
    if(res.status===200){
         setUserName(res?.data?.name);

    const formattedMessages = res?.data?.messages?.map(msg => ({
        direction: msg.direction,
        text: msg.text ?? msg?.listReply?.title ?? msg?.interactiveButtonReply?.title ?? ""
    }));

    setMessages(formattedMessages);
    }
  } catch (err) {
    console.error("Start Error:", err);
  }
}, []);


  return (
    <>
      {/* Dialog Box */}
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        // onClose={handleToggle}
        fullWidth
        maxWidth="xs"
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "10px",
            margin: 0,
            position: "fixed",
            bottom: 20,
            right: 20,
            display: "flex",
            flexDirection: "column",
            height: 500, // fixed height for scroll area
          },
        }}
      >
        {/* Header */}
      <Box
  sx={{
    backgroundColor: "#216DB4",
    color: "#fff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    px: 2,
    py: 1.5,
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
  }}
>
  {/* Title */}
  <Typography variant="h6" display="flex" justifyContent="center" alignItems="center" gap={1}>
    <FaUserAlt /> {userName}
  </Typography>

  {/* Icons on the right side */}
  {/* <Box display="flex" alignItems="center" gap={0.125}>
    <IconButton sx={{ color: "#fff" }} onClick={startChat}>
      <MdOutlineRestartAlt />
    </IconButton>
    <IconButton sx={{ color: "#fff" }} onClick={handleToggle}>
      <CloseIcon />
    </IconButton>
  </Box> */}
</Box>


        {/* Messages Scrollable Box */}
        <Box
          sx={{
            p: 2,
            overflowY: "auto",
            flexGrow: 1,
            backgroundColor: "#f9f9f9",
          }}
        >
          {messages.map((message, index) => (
            <Box
             ref={messagesEndRef}
              key={index}
              sx={{
                display: "flex",
                justifyContent:
                  message.direction === "outbound" ? "flex-start" : "flex-end",
                mb: 1.5,
              }}
            >
              <Box>
                {message.direction === "inbound" && (
                  <Box sx={{ fontSize: "0.8rem", color: "#216DB4", mb: 0.5 }}>
                    <FaRobot />
                  </Box>
                )}
                <Box
                  sx={{
                    backgroundColor:
                      message.sender === "bot" ? "#f1f1f1" : "#DCF8C6",
                    px: 2,
                    py: 1,
                    borderRadius: 2,
                    maxWidth: "250px",
                    wordBreak: "break-word",
                  }}
                >
                  <Typography variant="body2">{message.text}</Typography>
                </Box>

               
              </Box>
            </Box>
          ))}
        
        </Box>

        {/* Input Field */}

        {/* {!currentQuestion?.options?.length && (
          <Box px={2} py={1}>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Type your message..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSend(input)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => handleSend(input)} color="primary">
                      <SendIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        )} */}
      </Dialog>
    </>
  );
};

export default CrmChatbox;
